var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-col",
    { attrs: { cols: "12", md: "4", "ma-1": "" } },
    [
      _c(
        "v-card",
        [
          _c("v-card-title", { staticClass: "title font-weight-black" }),
          _vm._v(" "),
          _c("v-card-text", [
            _c("p", [_c("b", [_vm._v("Welcome to i-escape")])]),
            _vm._v(" "),
            _c(
              "p",
              [
                _vm._v("To get started click on the "),
                _c("v-icon", [_vm._v("hotel")]),
                _vm._v(" "),
                _c("b", [_vm._v("Reservations")]),
                _vm._v(
                  " button to view any upcoming bookings or enquiries from potential customers."
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c("p", [
              _vm._v("i-escape supports two types of booking - "),
              _c("b", [_vm._v("instant")]),
              _vm._v(
                " bookings made by i-escape's own booking website on your behalf, and "
              ),
              _c("b", [_vm._v("on-request")]),
              _vm._v(
                " bookings where the customers are free to enquire about custom quotes with you through the i-escape reservation administration system."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "All hotels have the on-request enquiry system enabled, but if you would like i-escape to automatically make bookings for you then please ensure that we always have your availability and rates information."
              ),
            ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "You can supply this through iCal feeds, channel manager connections, or through manually managing your availability and rates. Message us on "
              ),
              _c(
                "a",
                {
                  attrs: {
                    href: "mailto:channels@i-escape.com?subject=Channel%20Management",
                  },
                },
                [_vm._v("channels@i-escape.com")]
              ),
              _vm._v(" for more information"),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }